// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1lYtU","colMaxWidth":"Table_colMaxWidth__3Hl8R"};